
const config = {
    // base_url: "http://127.0.0.1:8000"
   
    // base_url: "https://marinizbackend.mariniz.com"
    base_url: "https://backend.happymarine.ae"
}
export default config

 

